<template>
  <el-dialog
    title="支付提示"
    :visible.sync="visible"
    width="90%"
    @closed="$emit('closed')"
    custom-class="pay-confirm-dialog"
  >
    <span>请选择支付方式</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="wechart-btn" round @click="payHandle('wechart')">
        <svg
          t="1739849490060"
          class="pay-icon"
          viewBox="0 0 1228 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1463"
          width="20"
          height="20"
        >
          <path
            d="M530.8928 703.1296a41.472 41.472 0 0 1-35.7376-19.8144l-2.7136-5.5808L278.272 394.752a18.7392 18.7392 0 0 1-2.048-8.1408 19.968 19.968 0 0 1 20.48-19.3536c4.608 0 8.8576 1.4336 12.288 3.84l234.3936 139.9296a64.4096 64.4096 0 0 0 54.528 5.9392L1116.2624 204.8C1004.9536 80.896 821.76 0 614.4 0 275.0464 0 0 216.576 0 483.6352c0 145.7152 82.7392 276.8896 212.2752 365.5168a38.1952 38.1952 0 0 1 17.2032 31.488 44.4928 44.4928 0 0 1-2.1504 12.3904l-27.6992 97.4848c-1.3312 4.608-3.328 9.3696-3.328 14.1312 0 10.752 9.216 19.3536 20.48 19.3536 4.4032 0 8.0384-1.536 11.776-3.584l134.5536-73.3184c10.1376-5.5296 20.7872-8.96 32.6144-8.96 6.2976 0 12.288 0.9216 18.0736 2.5088 62.72 17.0496 130.4576 26.5728 200.5504 26.5728C953.7024 967.168 1228.8 750.592 1228.8 483.6352c0-80.9472-25.4464-157.1328-70.0416-224.1024l-604.9792 436.992-4.4544 2.4064a42.1376 42.1376 0 0 1-18.432 4.1984z"
            fill="#15BA11"
            p-id="1464"
          ></path>
        </svg>
        微信支付
        <svg
          t="1739849895223"
          class="icon"
          viewBox="0 0 2399 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9725"
          width="26"
          height="20"
        >
          <path
            d="M999.456724 507.227696h141.805593V613.581891H999.456724v-106.354195z m0-162.258322h141.805593v107.71771H999.456724v-107.71771z m0 321.789614h141.805593v118.625832H999.456724v-118.625832z m1210.801598-644.942743c87.26498 0 158.167776 70.902796 158.167777 158.167776v672.21305c0 87.26498-70.902796 158.167776-158.167777 158.167776H35.451398S387.238349 965.368842 391.328895 654.48735V179.984021c0-87.26498 70.902796-158.167776 158.167776-158.167776h1660.761651z m-769.022636 188.165113v51.813582h179.984021v57.267643h58.631159v-57.267643h209.981358v58.631159h58.631158v-58.631159h179.984021v-51.813582h-179.984021v-57.267643h-58.631158v57.267643h-209.981358v-57.267643h-58.631159v57.267643h-179.984021zM869.92277 535.861518v-55.904128c-23.17976 12.271638-47.723036 23.17976-73.629827 34.087883V353.150466h79.083888v-55.904128h-79.083888V149.986684h-58.631159v148.62317h-102.263648v54.540612h102.263648v182.711052c-36.814913 12.271638-74.993342 23.17976-113.171771 32.724367l13.635153 57.267644c32.724368-9.544607 66.81225-20.45273 99.536618-31.360853v192.25566c0 20.45273-10.908123 31.360852-32.724367 31.360852-21.816245 0-43.63249-1.363515-65.448735-4.090546l12.271638 53.177097h73.629826c34.087883 5.454061 65.448735-17.725699 70.902797-51.813582 1.363515-5.454061 1.363515-10.908123 0-16.362184V568.585885c25.906791-9.544607 50.450067-21.816245 73.629827-32.724367z m474.503329 302.700399v-51.813581H1197.166445V668.122503h122.716378v-53.177097h-122.716378v-107.71771h122.716378v-54.540612h-122.716378v-107.71771h137.715046v-57.267643H1183.531292l21.816245-8.181092c-12.271638-43.63249-25.906791-87.26498-43.63249-129.533955l-54.540613 14.998669c17.725699 39.541944 34.087883 80.447403 46.359521 122.716378H1010.364847c17.725699-40.905459 32.724368-81.810919 43.63249-124.079893l-55.904128-10.908123c-27.270306 102.263648-73.629827 199.073236-137.715047 283.611185l19.089215 59.994674c23.17976-27.270306 44.996005-54.540613 64.08522-84.537949v463.595206h54.540612v-36.814914h346.33289z m280.884154 40.90546V544.04261c32.724368-36.814913 59.994674-76.356858 84.537949-118.625832h413.14514v-51.813582h-387.238349c6.817577-16.362184 13.635153-32.724368 19.089215-50.450067l-55.904128-9.544607c-8.181092 20.45273-16.362184 39.541944-25.906791 59.994674h-223.616511v51.813582h193.619174c-57.267643 85.901465-132.260985 158.167776-219.525965 214.071904l35.451398 46.35952c38.178429-25.906791 74.993342-54.540613 109.081225-84.537949v279.520639l57.267643-1.363515z m505.864181-173.166445V654.48735h-173.166445v-36.814913c42.268975-29.997337 83.174434-59.994674 122.716379-91.355526v-39.541944h-342.242344v51.813582h261.79494c-38.178429 24.543276-70.902796 46.359521-99.536618 64.085219V654.48735h-219.525965v53.177097h219.525965v91.355526c1.363515 13.635153-8.181092 27.270306-21.816245 28.633822h-6.817576c-20.45273 0-50.450067-1.363515-85.901465-4.090546l16.362184 55.904128h92.719041c31.360852 4.090546 59.994674-16.362184 64.08522-47.723036 1.363515-5.454061 1.363515-12.271638 0-17.725699V709.027963l171.802929-2.727031z"
            fill="#f25245"
            p-id="9726"
            data-spm-anchor-id="a313x.search_index.0.i1.67d83a81m5SfZr"
            class="selected"
          ></path>
        </svg>
      </el-button>
      <el-button class="alipay-btn" round @click="payHandle('alipay')">
        <svg
          t="1739849457018"
          class="pay-icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1311"
          width="20"
          height="20"
        >
          <path
            d="M1024.0512 701.0304V196.864A196.9664 196.9664 0 0 0 827.136 0H196.864A196.9664 196.9664 0 0 0 0 196.864v630.272A196.9152 196.9152 0 0 0 196.864 1024h630.272a197.12 197.12 0 0 0 193.8432-162.0992c-52.224-22.6304-278.528-120.32-396.4416-176.64-89.7024 108.6976-183.7056 173.9264-325.3248 173.9264s-236.1856-87.2448-224.8192-194.048c7.4752-70.0416 55.552-184.576 264.2944-164.9664 110.08 10.3424 160.4096 30.8736 250.1632 60.5184 23.1936-42.5984 42.496-89.4464 57.1392-139.264H248.064v-39.424h196.9152V311.1424H204.8V267.776h240.128V165.632s2.1504-15.9744 19.8144-15.9744h98.4576V267.776h256v43.4176h-256V381.952h208.8448a805.9904 805.9904 0 0 1-84.8384 212.6848c60.672 22.016 336.7936 106.3936 336.7936 106.3936zM283.5456 791.6032c-149.6576 0-173.312-94.464-165.376-133.9392 7.8336-39.3216 51.2-90.624 134.4-90.624 95.5904 0 181.248 24.4736 284.0576 74.5472-72.192 94.0032-160.9216 150.016-253.0816 150.016z"
            fill="#009FE8"
            p-id="1312"
          ></path>
        </svg>
        支付宝支付</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "payConfirm",
  data() {
    return {
      visible: false,
      resolve: null
    };
  },
  created() {
    this.visible = true;
  },
  methods: {
    init(options) {
      this.resolve = options.resolve;
    },
    payHandle(type) {
      this.visible = false;
      if (this.resolve) {
        this.resolve(type);
      }
    }
  }
};
</script>

<style lang="stylus">
.pay-confirm-dialog {
  .el-dialog__body {
    text-align: center;
    padding: 10px 10px;
  }
  .dialog-footer {
    .el-button {
      width: 100%;
      margin-top: 10px;
      margin-left: 0;
      height: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center
      &.wechart-btn {
        color: #67c23a;
        background: #f0f9eb;
        border-color: #c2e7b0;
      }
      &.alipay-btn {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
      > span {
        display: flex;
        align-items: center;
        svg {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
